import AddHandleLetter from './AddHandleLetter.jsx';

export {
  AddHandleLetter
};



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/add-handle-letters/index.js